export enum SideActionContentTypes {
  bulkEdit = 'bulkEdit',
}
